import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, DollarSign, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-16 bg-slate-50 relative overflow-hidden" data-id="element-56">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-amber-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-57" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-slate-200 p-8 md:p-12 rounded-3xl shadow-xl" data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-60">
            Entrenamiento Online
          </h2>

          <div className="flex flex-wrap justify-center gap-6 mb-8 text-lg md:text-xl text-slate-700" data-id="element-61">
            <div className="flex items-center gap-2" data-id="element-62">
              <Calendar className="w-6 h-6 text-amber-500" data-id="element-63" />
              <span data-id="element-64">Martes 27 de Enero</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <Clock className="w-6 h-6 text-amber-500" data-id="element-66" />
              <span data-id="element-67">En Vivo</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-68">
              <DollarSign className="w-6 h-6 text-amber-500" data-id="element-69" />
              <span className="text-slate-900 font-bold" data-id="element-70">Inversión: $15</span>
            </div>
          </div>

          <div className="space-y-2 mb-8" data-id="element-71">
            <p className="text-xl text-slate-600" data-id="element-72">👉 No es para motivarte.</p>
            <p className="text-xl font-bold text-slate-900" data-id="element-73">
              👉 Es para darte claridad, foco y estructura.
            </p>
          </div>

          <Button href="https://coneckta.co/taller-juegadesdeotronivel" size="xl" className="w-full md:w-auto min-w-[320px] shadow-xl hover:shadow-2xl mb-6" data-id="element-74">
            QUIERO JUGAR DESDE OTRO NIVEL
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-75" />
          </Button>

          <p className="text-slate-500 text-sm md:text-base max-w-lg mx-auto" data-id="element-76">
            Porque cuando un líder ve distinto, ya no puede volver a jugar
            igual.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-8 text-xl md:text-2xl font-medium text-slate-700 max-w-2xl mx-auto leading-relaxed" data-id="element-77">
          "Jugar desde otro nivel no es trabajar más. Es aprender a avanzar con
          inteligencia, claridad y sistemas."
        </motion.p>
      </div>
    </section>;
}